import * as Yup from 'yup'

import { EMPTY_LIST } from '../../../../constants/common'
import { isFormArrayFieldsEqual } from '../../../../utils/formHelpers'
import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
  isRemoveAllEntityActionType,
} from '../../../Entity'
import {
  FORM_ERROR_NAME_RESPONSIBLE_MANAGERS_LIMIT_EXCEEDED,
  formValidationSchemaNoChanged,
  RESPONSIBLE_MANAGERS_LIMIT,
} from '../../../Form'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../../Formik'
import { toUserSelectItem } from '../../../User'

import { BUILDING_EDIT_MANAGERS_FIELD_NAME_MANAGERS } from './BuildingsEditManagersActionModal.constants'

export function getInitialValues({ itemAction, users }) {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    [BUILDING_EDIT_MANAGERS_FIELD_NAME_MANAGERS]:
      users?.map(toUserSelectItem) || EMPTY_LIST,
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]: itemAction
      ? actionTypeOptions[EntityActionTypeSelectOptionValue.Edit]
      : actionTypeOptions[EntityActionTypeSelectOptionValue.Add],
  }
}

export function getValidationSchema({ initialValues, itemAction }) {
  return Yup.object({
    [BUILDING_EDIT_MANAGERS_FIELD_NAME_MANAGERS]: Yup.array()
      .max(
        RESPONSIBLE_MANAGERS_LIMIT,
        FORM_ERROR_NAME_RESPONSIBLE_MANAGERS_LIMIT_EXCEEDED
      )
      .when(FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME, {
        is: actionType =>
          !isRemoveAllEntityActionType(actionType) && !itemAction,
        then: schema => schema.of(Yup.object()).min(1, true),
      }),
  }).when(EMPTY_LIST, {
    is: () => itemAction,
    then: schema =>
      schema.concat(
        formValidationSchemaNoChanged({
          initialValues,
          isEqual: isFormArrayFieldsEqual,
          isEqualProps: {
            name: BUILDING_EDIT_MANAGERS_FIELD_NAME_MANAGERS,
          },
        })
      ),
  })
}
